$(function () {
    'use strict';

    function Slideable ($root) {
        var classes = {
            gradient: 'slideable-block__hidden-part_gradient-bottom',
            shown: 'slideable-block_shown',
            showHideable: 'slideable-block__collapsable_showed',
            hideShowAll: 'slideable-block__show-all_hidden',
            showAll: 'slideable-block__show-all'
        };

        var $elements = {
            root: $(),
            toggle: $(),
            hideable: $(),
            images: $()
        };

        var height = {};

        var calcSizes = function () {
            if ($elements.root.hasClass('slideable-block_instant-shown')) {
                height.closed = 0;
            }
            else {
                height.closed = $elements.hideable.outerHeight(true);
            }

            if ($elements.root.data('max-height')) {
                height.opened = window.parseInt($elements.root.data('max-height'), 10);
            }
            else {
                $elements.hideable.css({'max-height': 'none'});
                height.opened = (window.MediaQueryState.phones || $elements.root.hasClass('slideable-block_instant'))
                    ? 'none' : $elements.hideable.outerHeight(true);
                $elements.hideable.css({'max-height': ''});
            }

            $elements.root.data('height', height.opened);
        };

        var toggle = function (show) {
            var toggleText = {
                show: 'Читать далее',
                hide: 'Свернуть'
            };

            if ($root.hasClass('slideable-block_single-use')) {
                $elements.toggle.toggle();
            }

            if (_($elements.toggle.data('toggle-text')).isObject()) {
                toggleText = $elements.toggle.data('toggle-text');
            }
            $elements.toggle.html(
                $elements.toggle.html().replace(
                    show ? toggleText.show : toggleText.hide,
                    show ? toggleText.hide : toggleText.show
                )
            );

            $elements.root.toggleClass(classes.shown, show);
            $elements.hideable.toggleClass(classes.showHideable, show);

            if ($elements.toggle.hasClass(classes.showAll)) {
                $elements.toggle.toggleClass(classes.hideShowAll, show);
            }

            _.defer(function () {
                if ($elements.root.data('height') !== height.opened) {
                    height.opened = $elements.root.data('height');
                }

                $elements.hideable.css({
                    'max-height': show ? height.opened : height.closed
                });

                var $parentCollapsable = $elements.root.parents('.slideable-block__collapsable');
                if ($parentCollapsable.length > 0 && $parentCollapsable.hasClass(classes.showHideable) && !$parentCollapsable.parents('.slideable-block').hasClass('slideable-block_scroll')) {
                    var parentHeight = window.parseInt($parentCollapsable.css('max-height'), 10) + height.opened;
                    $parentCollapsable.css('max-height', parentHeight);
                    $parentCollapsable.parents('.slideable-block').data('height', parentHeight);
                }

                _.defer(function () {
                    $elements.hideable.parents('.grid_masonry').trigger('Grid::recalc');
                });
            });
        };

        var init = function ($root) {
            $elements.root = $root;

            var $innerSlideable = $root.find('.slideable-block');
            $innerSlideable.each(function () {
                $(this).data('prev', $(this).prev());
                $(this).detach();
            });

            $elements.toggle = $root.find('.slideable-block__toggle, .slideable-block__show-all');
            $elements.hideable = $root.find($('.slideable-block__collapsable'));
            $elements.images = $elements.hideable.find('img');

            $innerSlideable.each(function () {
                $(this).insertAfter($(this).data('prev'));
            });

            _.defer(function () {
                calcSizes();

                if (typeof [].reduce === 'function') {
                    var targetHeight = (
                        $elements.hideable
                            .children()
                            .map(function () {
                                return $(this).outerHeight();
                            })
                            .toArray()
                            .reduce(function (memo, right) {
                                return memo + right;
                            }, 0)
                    );

                    if (Math.abs(targetHeight - height.closed) < 3 && !$elements.hideable.hasClass(classes.showHideable)) {
                        $elements.toggle.remove();
                    }
                }

                if ($elements.root.hasClass(classes.shown)) {
                    $elements.hideable.css({'max-height': height.opened});
                }

                $elements.images.each(function (index, img) {
                    $(img).on('load', function () {
                        if (_(height.opened).isNumber()) {
                            height.opened += $(img).height();
                            $elements.root.data('height', height.opened);
                        }
                    });
                });

                if (_(height.opened).isNumber() && (height.opened < $elements.root.data('min-height'))) {
                    $elements.toggle.hide();
                    return false;
                }
            });

            $elements.toggle.on('click', function (event) {
                event.preventDefault();
                toggle(!$elements.root.hasClass(classes.shown));
                $elements.toggle.blur();
            });

            $elements.root.data('processed', true);

            if ($elements.hideable.parents('.grid_masonry').length > 0) {
                _.defer(function () {
                    $elements.hideable.parents('.grid_masonry').trigger('Grid::recalc');
                });
            }
        };

        init($root);
    }

    $(document).on('ready Reviews::newItemsAdded', function () {
        $('.slideable-block').each(function () {
            if (!$(this).data('processed')) {
                var slideable = new Slideable($(this));
            }
        });
    });
});
